import { useState, useEffect } from 'react';

export default function ReviewsSlider() {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadReviews() {
      try {
        setLoading(true);
        const res = await fetch('https://api.dev.auxo.dk/public/content/reviews');
        if (res.ok) {
          const data = await res.json();
          if (Array.isArray(data) && data.length > 0) {
            setReviews(data);
          }
        }
      } catch (err) {
        console.error('Kunne ikke hente anmeldelser:', err);
      } finally {
        setLoading(false);
      }
    }

    loadReviews();
  }, []);

  if (loading) {
    return null;
  }

  // If reviews are present in CMS, render the infinite slider
  if (reviews.length > 0) {
    // Duplicate reviews array for smooth infinite marquee looping
    const duplicatedReviews = [...reviews, ...reviews, ...reviews];

    return (
      <section className="py-20 bg-slate-900 text-white overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-12 text-center">
          <h2 className="text-2xl sm:text-3xl font-extrabold tracking-tight text-white">
            Hvad vores kunder siger
          </h2>
          <p className="mt-2 text-slate-400 text-base max-w-xl mx-auto">
            Vi sætter en ære i tilfredse kunder og stabilt samarbejde.
          </p>
        </div>

        {/* Infinite Slider Marquee */}
        <div className="relative w-full overflow-hidden">
          <div className="animate-infinite-scroll flex gap-6">
            {duplicatedReviews.map((rev, idx) => (
              <div
                key={idx}
                className="w-[300px] sm:w-[360px] lg:w-[400px] shrink-0 bg-slate-800/80 border border-slate-700/80 p-6 flex flex-col justify-between shadow-lg"
              >
                <div>
                  <div className="flex items-center gap-1 text-amber-400 mb-3">
                    {[...Array(rev.rating || 5)].map((_, i) => (
                      <i key={i} className="fa-solid fa-star text-xs" aria-hidden="true" />
                    ))}
                  </div>
                  <p className="text-slate-300 text-sm leading-relaxed italic">
                    "{rev.comment}"
                  </p>
                </div>
                <div className="mt-6 pt-4 border-t border-slate-700 flex items-center justify-between">
                  <div>
                    <h4 className="font-bold text-white text-sm">{rev.author}</h4>
                    {rev.location && <span className="text-xs text-slate-400">{rev.location}</span>}
                  </div>
                  {rev.service_type && (
                    <span className="text-xs font-medium px-2.5 py-1 bg-slate-700 text-emerald-300">
                      {rev.service_type}
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  // If no reviews yet in CMS, return null (never fabricating fake reviews)
  return null;
}
